/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import { queryOptions, useQuery, useSuspenseQuery } from '@tanstack/react-query'
import type {
	UseQueryOptions,
	UseQueryResult,
	UseSuspenseQueryOptions,
	UseSuspenseQueryResult,
} from '@tanstack/react-query'
import type { AxiosError, AxiosRequestConfig } from 'axios'
import { campaignAvailabilityCheckShow } from '../../axios/campaignAvailabilityCheckShow'
import type {
	CampaignAvailabilityCheckShowError,
	CampaignAvailabilityCheckShowPathParams,
	CampaignAvailabilityCheckShowResponse,
} from '../../types/CampaignAvailabilityCheckShow'

export const campaignAvailabilityCheckShowQueryKey = (campaign: CampaignAvailabilityCheckShowPathParams['campaign']) =>
	[{ url: '/interview-scheduling/campaigns/:campaign/availability-check', params: { campaign } }] as const

export type CampaignAvailabilityCheckShowQueryKey = ReturnType<typeof campaignAvailabilityCheckShowQueryKey>

/** @see backend/nexus/modules/InterviewScheduling/Http/Controllers/CampaignAvailabilityCheckController.php CampaignAvailabilityCheckController::show */
export function campaignAvailabilityCheckShowQueryOptions(
	campaign: CampaignAvailabilityCheckShowPathParams['campaign'],
	config?: AxiosRequestConfig,
) {
	return queryOptions<
		CampaignAvailabilityCheckShowResponse,
		AxiosError<CampaignAvailabilityCheckShowError>,
		CampaignAvailabilityCheckShowResponse,
		CampaignAvailabilityCheckShowQueryKey
	>({
		queryKey: campaignAvailabilityCheckShowQueryKey(campaign),
		queryFn: ({ signal }) => campaignAvailabilityCheckShow(campaign, { signal, ...config }).then(res => res.data),
		enabled: !!campaign,
	})
}

/** @see backend/nexus/modules/InterviewScheduling/Http/Controllers/CampaignAvailabilityCheckController.php CampaignAvailabilityCheckController::show */
export function useCampaignAvailabilityCheckShow<TSelectData = CampaignAvailabilityCheckShowResponse>(
	campaign: CampaignAvailabilityCheckShowPathParams['campaign'],
	options?:
		& Partial<
			Omit<
				UseQueryOptions<
					CampaignAvailabilityCheckShowResponse,
					AxiosError<CampaignAvailabilityCheckShowError>,
					TSelectData,
					CampaignAvailabilityCheckShowQueryKey
				>,
				'queryKey' | 'queryFn'
			>
		>
		& { queryKey?: readonly unknown[] },
): UseQueryResult<TSelectData, AxiosError<CampaignAvailabilityCheckShowError>> {
	const { queryKey: customQueryKey, ...opts } = options ?? {}
	return useQuery({
		...campaignAvailabilityCheckShowQueryOptions(campaign),
		...opts as any,
		...(customQueryKey ? { queryKey: customQueryKey as any } : {}),
	})
}

/** @see backend/nexus/modules/InterviewScheduling/Http/Controllers/CampaignAvailabilityCheckController.php CampaignAvailabilityCheckController::show */
export function useCampaignAvailabilityCheckShowSuspense<TSelectData = CampaignAvailabilityCheckShowResponse>(
	campaign: CampaignAvailabilityCheckShowPathParams['campaign'],
	options?:
		& Partial<
			Omit<
				UseSuspenseQueryOptions<
					CampaignAvailabilityCheckShowResponse,
					AxiosError<CampaignAvailabilityCheckShowError>,
					TSelectData,
					CampaignAvailabilityCheckShowQueryKey
				>,
				'queryKey' | 'queryFn'
			>
		>
		& { queryKey?: readonly unknown[] },
): UseSuspenseQueryResult<TSelectData, AxiosError<CampaignAvailabilityCheckShowError>> {
	const { queryKey: customQueryKey, ...opts } = options ?? {}
	return useSuspenseQuery({
		...campaignAvailabilityCheckShowQueryOptions(campaign),
		...opts as any,
		...(customQueryKey ? { queryKey: customQueryKey as any } : {}),
	})
}
